import { Modal, Button } from "react-bootstrap";
import CommunicationForm from "../forms/CommunicationForm"; // Adjust import path as needed

export default function CommunicationFormModal({
  show,
  onClose,
  formSubmitted,
  submissionResult,
  setFormSubmitted,
  setSubmissionResult,
  selectMessageById,
  setSelectedComm,
  contextProvider,
  replyToCommId,
  fetchedPatient,
  contextPatient,
  fetchedEncounter,
  communicationService,
  resolvedRecipients,
  fhirClient,
  selectedComm,
  isReplyMode,
  encounter,
  contextEncounter
}) {
  const handleClose = () => {
    onClose();
    setFormSubmitted(false);
    setSubmissionResult("");
  };


  return (
    <Modal show={show} onHide={handleClose} size="xl" centered>
      <Modal.Header closeButton>
        <Modal.Title>{formSubmitted ? "Success" : "Send Message"}</Modal.Title>
      </Modal.Header>

      <Modal.Body>
        {formSubmitted ? (
          <div className="text-center p-4">
            <h5>{submissionResult || "✅ Message sent successfully!"}</h5>
            <Button variant="primary" className="mt-3" onClick={handleClose}>
              Close
            </Button>
          </div>
        ) : (
          <CommunicationForm

            selectMessageById={selectMessageById}
            setSelectedComm={setSelectedComm}
            contextProvider={contextProvider}
            patientData={fetchedPatient}
            fetchedEncounter={fetchedEncounter}
            commService={communicationService}
            initialRecipients={resolvedRecipients}
            replyToCommId={replyToCommId}
            fhirClient={fhirClient}
            onCloseForm={() => setFormSubmitted(true)}
            onSetResult={setSubmissionResult}
            onSendLocalReply={(msg) => {
              setSelectedComm((prev) => ({
                ...prev,
                injectedMessages: [...(prev?.injectedMessages || []), msg],
              }));
            }}
            selectedComm={selectedComm}
            isReplyMode={isReplyMode}
          />
        )}
      </Modal.Body>
    </Modal>
  );
}
